import React from "react";
import {makeStyles} from "@material-ui/styles";
import AppsTwoToneIcon from '@material-ui/icons/AppsTwoTone';
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles(theme => ({
    label: {

        "&:hover": {
            color: 'blue',
            textDecoration: 'underline',
            cursor: 'pointer'
        },
    }
}));

const CalculatorTileLabel = (props) => {

    const styles = useStyles();
    return (
        <div>
            <Grid container alignItems={'center'}>
                <AppsTwoToneIcon fontSize={'small'} style={{margin: '5px'}}/>
                <div className={styles.label}>
                    {props.name}
                </div>
            </Grid>

        </div>
    )
};

export default CalculatorTileLabel;